module.exports = __webpack_public_path__ + "img/solve-an-exam_icon.1fe916d1.svg";